export default __webpack_public_path__ + "static/media/duotone-eye-closed-svgrepo-com.7d44abc9.svg";